<template>
  <div>
    <slot name="backLink" />
    <ScArticle
      v-if="faqDetails"
      class="sc__systems-faq--details"
      v-bind="faqDetails"
      :related-content="getRelatedContent"
      :faq-link-builder="generateFaqLink"
      @on-related-faq-clicked="$emit('onFaqClicked', $event)"
      @expand-collapse-element="expandCollapseElement"
    >
      <template #content>
        <component
          :is="{ template: `<div>${compiledFaqContent}</div>`}"
          @embedded-faq-click="$emit('onFaqClicked', $event)"
          @expand-collapse-all="expandCollapseAll"
        />
      </template>
    </ScArticle>
    <ScEfmSurvey
      v-if="shouldRenderSurvey"
      :product-id="getSurveyProductId"
      :product-name="getSurveyProductName"
      accessible-label="Survey"
      :base-url="translations.commonSettings.generalSettings.faqSurveyUrl"
      :business-segment="faqDetails.kbase"
      :content-id="faqDetails.contentID"
      :content-locale="faqDetails.contentLocale"
      :content-title="faqDetails.title"
      :content-type="contentType"
      :content-version="faqDetails.contentVersion"
      :customer-locale="getLocale()"
      :publication-id="faqDetails.publishedId"
      :source="systemConfig.defaultSurveySource"
      :topic-tag="getSurveyTagName"
      :tracking-id="uuidv4()"
    />
  </div>
</template>

<script src="./index.js"></script>
